import { userConstants } from './constantData';

const commonDimensions = [
  'v_content_name', /* 17 */
  'v_content_type', /* 18 */
  'v_content_id', /* 19 */
  'v_genre', /* 20 */
  'v_serie_name', /* 24 */
  'v_season', /* 25 */
  'v_content_locked', /* 37 */
  'v_is_kids', /* 39 */
  'v_episode_number', /* 52 */
  'v_episode_name', /* 55 */
  'v_is_betting', /* 81 */
];

export const MY_LIST_DATA = {
  add_remove: {
    add: {
      hash: 'e-036.069.001.000.000.163',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
        'v_tab', /* 33 */
        'v_provider_name', /* 35 */
      ],
    },
    remove: {
      hash: 'e-036.069.001.000.000.164',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
        'v_tab', /* 33 */
        'v_provider_name', /* 35 */
      ],
    },
  },
  lander: {
    page_view: {
      hash: 'p-033.001.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    watch: {
      hash: 'e-033.001.001.000.000.009',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
        'v_play_source', /* 21 */
        'v_list_position', /* 32 */
        'v_transmission_type', /* 34 */
        'v_channel_id', /* 50 */
        'v_content_player_type', /* 53 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
      ],
    },
    back: {
      hash: 'e-033.001.001.000.000.028',
      event: 'interactions',
      dimensions: [...userConstants],
    },
  },
};
